export default __webpack_public_path__ + "static/media/cola-color-removebg-preview.58ad17df.png";